import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerResourceRequestAllocationRequest } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerResourceRequestAllocationRequestSlice = createSlice({
  name: "ProjectManagerResourceRequestAllocationRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerResourceRequestAllocationRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerResourceRequestAllocationRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerResourceRequestAllocationRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fetch ProjectManager Allocation Request  List";
      });
  },
});

export default ProjectManagerResourceRequestAllocationRequestSlice.reducer;
